@if (symbol() && position(); as pos) {
  <div class="bb-sym-card"
       role="tooltip"
       [style.left.px]="pos.left"
       [style.top.px]="pos.top">
    <header class="bb-sym-card__header">
      <span class="bb-sym-card__symbol">{{ symbol() }}</span>
      @if (quote(); as q) {
        <span class="bb-sym-card__price">{{ q.price | number:'1.2-8' }}</span>
        <span class="bb-sym-card__delta" [class]="'is-' + deltaSign()">
          {{ q.delta1d > 0 ? '▲' : q.delta1d < 0 ? '▼' : '–' }}
          {{ (q.delta1d * 100) | number:'1.2-2' }}%
        </span>
      }
    </header>
    @if (quote(); as q) {
      @if (q.sparkline?.length) {
        <svg class="bb-sym-card__spark" viewBox="0 0 220 32" preserveAspectRatio="none">
          <path [attr.d]="sparklinePath(q.sparkline!)" fill="none" stroke="currentColor" stroke-width="1.2" />
        </svg>
      }
      <dl class="bb-sym-card__rows">
        @if (q.volume !== undefined) {
          <div><dt>Volume</dt><dd>{{ q.volume | number:'1.0-0' }}</dd></div>
        }
        @if (q.exchanges?.length) {
          <div><dt>Venues</dt><dd>{{ q.exchanges!.join(' · ') }}</dd></div>
        }
      </dl>
    } @else if (error(); as err) {
      <p class="bb-sym-card__error" role="alert">{{ err }}</p>
    } @else {
      <p class="bb-sym-card__loading">Loading quote…</p>
    }
  </div>
}
